import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private static promise: Promise<any>;
  private static isLoaded = false;

  constructor() { }

  /**
   * Carrega a API do Google Maps dinamicamente
   * @returns Promise que resolve quando a API está carregada
   */
  static load(): Promise<any> {
    // Se já foi carregado, retorna Promise resolvida
    if (this.isLoaded) {
      return Promise.resolve((window as any).google);
    }

    // Se já existe uma Promise em andamento, retorna ela
    if (this.promise) {
      return this.promise;
    }

    // Cria nova Promise para carregar o script
    this.promise = new Promise((resolve, reject) => {
      const callbackName = '__googleMapsReady';
      (window as any)[callbackName] = () => {
        this.isLoaded = true;
        resolve((window as any).google);
        delete (window as any)[callbackName];
      };

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&loading=async&libraries=geometry,places,routes,marker&v=weekly&callback=${callbackName}`;

      script.onerror = (error) => {
        console.error('Erro ao carregar Google Maps API:', error);
        reject(error);
      };

      document.head.appendChild(script);
    });

    return this.promise;
  }

  /**
   * Verifica se a API do Google Maps está carregada
   * @returns boolean
   */
  static isGoogleMapsLoaded(): boolean {
    return this.isLoaded && !!(window as any).google && !!(window as any).google.maps;
  }

  /**
   * Carrega a API e retorna uma Promise
   * Método de instância para uso em componentes
   */
  loadGoogleMaps(): Promise<any> {
    return GoogleMapsLoaderService.load();
  }

  /**
   * Verifica se está carregado
   * Método de instância para uso em componentes
   */
  isLoaded(): boolean {
    return GoogleMapsLoaderService.isGoogleMapsLoaded();
  }
}
